module.exports = __webpack_public_path__ + "static/media/atp-1000.977d963a.png";